import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {AuditModel} from '@/libs/Api';
import {AuditsDataService} from '@/libs/audits/audits-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const auditsStore = registerCrudStore<AuditModel, AuditModel>(BusinessModule.Audit, new AuditsDataService());
